import gql from 'graphql-tag'

export const GET_FAVORITES = gql`
  query {
    favorites {
      _id
      tipo
      titulo
      principioAtivo
    }
  }
`
